import { AFFILIATOR_REGISTRATION, AFFILIATOR_REGISTRATION_FORM } from '../Action/type';

const initialState = {
    isResistered: false,
    user: {}
}

export default function(state = initialState, action) {
    switch (action.type) {
        case AFFILIATOR_REGISTRATION:
            return {
                ...state,
                user: action.payload
            };
        case AFFILIATOR_REGISTRATION_FORM:
            return {
                ...state,
                user: action.payload
            }

        default:
            return state;
    }

}